import {
  UPDATE_MEMBER_SALARY_SUCCESS,
  UPDATE_MEMBER_SALARY_FAIL,
  GET_MEMBER_SALARY_SUCCESS,
  GET_MEMBER_SALARY_FAIL,
} from "../actionTypes";

const initialState = {
  salaryData: null,
  error: null,
};

const updateMemberSalaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MEMBER_SALARY_SUCCESS:
      return { ...state, salaryData: action.payload, error: null };
    case UPDATE_MEMBER_SALARY_FAIL:
      return { ...state, error: action.payload };
    case GET_MEMBER_SALARY_SUCCESS:
      return { ...state, salaryData: action.payload, error: null };
    case GET_MEMBER_SALARY_FAIL:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default updateMemberSalaryReducer;
